import script from "./SliderCategoriaParceiros.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderCategoriaParceiros.vue?vue&type=script&setup=true&lang=js"

import "./SliderCategoriaParceiros.vue?vue&type=style&index=0&id=c43bcb62&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c43bcb62"]])

export default __exports__